import { createSlice } from '@reduxjs/toolkit'
import {promiseCallApi} from "../../tools/commons";

const initialState = {
  faq_categories: null,
}

export const guideListSlice = createSlice({
  name: 'guide',
  initialState,
  reducers: {
    // ここに定義したキーがAction Creator関数の名前となる
    hydrate: (state, action) => {
      return {
        ...state,
        faq_categories: action.payload
      }
    },
    setGuideLists: (state, action) => {
      return {
        ...state,
        faq_categories: action.payload,
      }
    }
  }
})

export const { setGuideLists, hydrate } = guideListSlice.actions
export default guideListSlice.reducer